import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";

Abacus.Overlay = {};

$(document).ready(function(){
	if (!Abacus.PreventDefault.Overlay){
		Abacus.Overlay.Instance = new Overlay();
	}
});

let OverlayOptions = {
	createOverlay: true,
	classes: {
		overlayClass: 'overlay',
		effectTrigger: 'open',
	},
	closeOnClick: true
}

class Overlay extends Class {
	
	constructor(options, element){
		super();
		this.setOptions(OverlayOptions, options);
		this.closeOverlay = false;
		if(this.options.createOverlay) this.createOverlay();
		this.element = $('.' + this.options.classes.overlayClass);
		if(Abacus.isNativeAndroid()) $('html').addClass('andriodstockbrowser');
	}

	createOverlay() {
		if($('.' + this.options.classes.overlayClass).length === 0) {
			$(document.body).append("<div class='"+this.options.classes.overlayClass+"'></div>");
		}
	}

	setupEvents() {
		var self = this;
		if(this.options.closeOnClick) {
			this.element.on("click", function(){
				if(!self.preventOverlayClosing) self.close();
			});
		}

		$(window).on('abacus:closeOverlay', function(e, value) { // triggered in overlay.class.js
			self.preventOverlayClosing = true;
		});
	}

	open() {
		this.element.addClass(this.options.classes.effectTrigger);
		this.setupEvents();
	}

	resetStyle() {
		this.element.attr('class', '');
		this.element.addClass(this.options.classes.overlayClass);
		this.element.addClass(this.options.classes.effectTrigger);
	}

	removeStyle(style) {
		this.element.removeClass(style);
	}

	setStyle(style) {
		this.element.addClass(style);
	}

	close() {
		this.element.removeClass(this.options.classes.effectTrigger);
		$(window).trigger("abacus:closeAll", [true]);
		this.preventOverlayClosing = false;
	}
}




// WEBPACK FOOTER //
// ./Javascript/core/classes/popups/overlay.class.js